import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const deleteKitByKitId = async ({ kitId }) => {
	try {
		const kitDocRef = firestore.collection('kits').doc(kitId)
		return await kitDocRef.update({ deleted: true, modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp() })
	} catch (error) {
		return Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, kitId, error))
	}
}

export default deleteKitByKitId



// WEBPACK FOOTER //
// ./src/dataservices/deleteKitByKitId.js